@if (sidebarConfig; as sidebar) {
  <div
    class="bd-sidebar"
    *transloco="let t; scope: 'featureLayout'"
    data-id="sidebar"
  >
    <div class="bd-sidebar-logo-container">
      <bd-logo [isLastToolbarItem]="true" (logoClicked)="onLogoClick()" />
    </div>
    <div class="flex flex-col flex-1">
      <p-accordion [multiple]="true" [value]="0" class="bd-sidebar-accordion">
        @for (
          sidebarItem of filteredSidebarItems$ | async;
          let index = $index;
          track sidebarItem.dataId
        ) {
          @let isChildActive =
            sidebarItem | sidebarChildActive: sidebar.selectedItem;
          <p-accordion-panel
            class="{{
              !sidebarItem.subItems?.length ? 'bd-no-content-accordion' : ''
            }}"
            [value]="index"
          >
            <p-accordion-header [attr.data-id]="sidebarItem.name + '-header'">
              <ng-template #toggleicon let-active="active">
                @if (sidebarItem.subItems?.length) {
                  <i
                    data-id="accordion-toggle-icon"
                    [ngClass]="active ? 'ui-up' : 'ui-down'"
                  ></i>
                }
              </ng-template>
              <a
                class="bd-sidebar-item"
                [ngClass]="{
                  'bd-sidebar-active-item':
                    sidebar.selectedItem === sidebarItem.name,
                  'bd-sidebar-child-active': isChildActive,
                }"
                [routerLink]="sidebarItem.routerLink"
                [attr.data-id]="sidebarItem.dataId"
                (click)="onItemClick(sidebarItem.routerLink)"
                tabindex="-1"
              >
                <div class="bd-icon-wrapper flex">
                  <div class="bd-icon">
                    <i
                      [attr.data-id]="sidebarItem.name + '-icon'"
                      [ngClass]="sidebarItem.icon"
                    ></i>
                  </div>
                </div>
                <span
                  [ngClass]="
                    sidebar.selectedItem === sidebarItem.name
                      ? 'bd-label-regular'
                      : 'bd-body-regular'
                  "
                  >{{ t('featureLayout.sidebar.' + sidebarItem.name) }}</span
                >
              </a>
            </p-accordion-header>
            @for (subItem of sidebarItem.subItems; track subItem.dataId) {
              <p-accordion-content>
                <a
                  [ngClass]="
                    sidebar.selectedItem === subItem.name
                      ? 'bd-label-regular bd-sidebar-active-item'
                      : 'bd-body-regular'
                  "
                  class="bd-sidebar-item bd-subitem"
                  [routerLink]="subItem.routerLink"
                  [attr.data-id]="subItem.dataId"
                  (click)="onItemClick(subItem.routerLink)"
                >
                  {{ t('featureLayout.sidebar.' + subItem.name) }}</a
                ></p-accordion-content
              >
            }
          </p-accordion-panel>
        }
      </p-accordion>
    </div>
    <div class="flex flex-col gap-8">
      <p-menu
        data-id="support-menu"
        styleClass="bd-sidebar-menu"
        [model]="(supportMenuItems | translateMenuItems | async) ?? []"
        [dt]="navigationMenuPreset"
      >
        <ng-template #item let-item>
          <a
            [attr.data-id]="'support-menu-item-' + item.id"
            class="bd-sidebar-item cursor-pointer"
            [id]="item.id"
          >
            @if (item.icon) {
              <div class="bd-icon-wrapper flex">
                <div class="bd-icon">
                  <i
                    [attr.data-id]="item.id + '-icon'"
                    [ngClass]="item.icon"
                  ></i>
                </div>
              </div>
            }
            {{ item.label }}
          </a>
        </ng-template>
      </p-menu>
      <div class="bd-sidebar-footer bd-caption" data-id="sidebar-footer">
        <div
          class="cursor-default w-fit"
          positionLeft="30"
          tooltipPosition="top"
          [pTooltip]="tooltipContent"
          bdRichTooltip
          data-id="sidebar-footer-text"
          [tooltipDisabled]="!appVersion"
          (mouseover)="onVersionViewed()"
          (focus)="onVersionViewed()"
          tabindex="0"
          tooltipEvent="both"
        >
          {{
            t('featureLayout.sidebar.madeByBizzdesign', {
              currentYear: currentYear,
            })
          }}
          <ng-template #tooltipContent>
            @let content =
              t('featureLayout.sidebar.versionTooltipContent', {
                frontendVersion: appVersion?.frontendVersion,
                backendVersion: appVersion?.backendVersion,
              });
            <bd-rich-tooltip
              [title]="t('featureLayout.sidebar.versionTooltipTitle')"
              [content]="content"
              [buttonLabel]="t('uiComponents.tooltip.copy')"
              (buttonAction)="copyValueToClipboard(content)"
            ></bd-rich-tooltip>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
}
